export const INQUIRY_TYPES = [
  { value: "course", label: "Course Enrollment" },
  { value: "wedding", label: "Wedding Chenda Melam" },
  { value: "temple", label: "Temple / Festival Program" },
  { value: "corporate", label: "Corporate / Inauguration" },
  { value: "housewarming", label: "Housewarming / Griha Pravesh" },
  { value: "other", label: "Other Event" },
];

export const EVENT_TYPES = [
  "Groom Entry",
  "Bride Entry",
  "Baraat / Procession",
  "Muhurtham",
  "Reception",
  "Full Wedding Package",
  "Temple Utsavam",
  "Corporate Event",
  "Housewarming",
  "Other",
];

export const MELAM_TYPES = [
  "Not sure — recommend for me",
  "Compact Entry Ensemble",
  "Panchari Melam",
  "Pandi Melam",
  "Chempada Melam",
  "Panchavadyam",
  "Custom / Mixed",
];

export const REFERRAL_SOURCES = [
  { key: "friends", label: "Friends" },
  { key: "family", label: "Family" },
  { key: "socialMedia", label: "Social Media" },
  { key: "google", label: "Google Search" },
  { key: "weddingPlanner", label: "Wedding Planner" },
];
